import React, { useEffect, useState } from "react";
import "./styles.scss";
import { Button, InputBox, KeywordCheckBox } from "../../../../components";
import { CheckValidity } from "../../../../utils/formValidity";
import draftToHtml from "draftjs-to-html";
import { ContentState, convertToRaw, EditorState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import { useSelector } from "react-redux";
import htmlToDraft from "html-to-draftjs";
import { getNewsKeywords } from "../../../news/service/news.service";

const English = ({ onChange, finish }) => {
  const [formData, setFormData] = useState({
    titleEN: {
      key: "titleEN",
      label: "Title (EN)",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "-",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
      mainLayerStyles: "mb-3",
    },
    descriptionEN: {
      key: "descriptionEN",
      label: "Description (EN)",
      size: "lg",
      elementConfig: {
        type: "text",
        placeholder: "-",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    keyWord: {
      key: "keyWord",
      label: "",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "-",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
      mainLayerStyles: "mb-3",
    },
  });

  const { selectNews, isOpenAddUpdateNewsModal, isOpenNewsViewModal } =
    useSelector(({ newsReducer }) => newsReducer);

  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [selectKeyword, setSelectKeyword] = useState("");
  const [suggestion, setSuggestions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const onEditorStateChange = (editorState) => {
    setEditorState(editorState);
    const updateNewsForm = {
      ...formData,
      descriptionEN: {
        ...formData.descriptionEN,
        value: draftToHtml(convertToRaw(editorState.getCurrentContent())),
      },
    };
    setFormData(updateNewsForm);
  };

  const handleChange = async (event, inputIdentity) => {
    const updateNewsForm = {
      ...formData,
    };

    updateNewsForm[inputIdentity].value = event;
    let validityRes = await CheckValidity(
      inputIdentity,
      updateNewsForm[inputIdentity].value,
      updateNewsForm[inputIdentity].validation
    );

    if (validityRes) {
      updateNewsForm[inputIdentity].isValid = validityRes.isValid;
      updateNewsForm[inputIdentity].invalidReason = validityRes.reason;
      updateNewsForm[inputIdentity].value = event;
      updateNewsForm[inputIdentity].touched = true;
      console.log("required_validation", validityRes);

      let formIsValid = false;
      for (let inputIdentifier in updateNewsForm) {
        formIsValid = updateNewsForm[inputIdentifier].valid && formIsValid;
      }
      console.log("formIsValid", formIsValid);
      setFormData(updateNewsForm);
    }
  };

  const clearAll = () => {
    const updateNewsForm = { ...formData };
    for (let key in updateNewsForm) {
      updateNewsForm[key].value = "";
      updateNewsForm[key].isValid = false;
      updateNewsForm[key].touched = false;
    }
    setEditorState(EditorState.createEmpty());
    setFormData(updateNewsForm);
    setIsLoading(false);
    setSelectKeyword("");
    setSuggestions([]);
  };

  useEffect(() => {
    onChange(formData);
  }, [formData]);

  useEffect(() => {
    if (finish) {
      clearAll();
    }
  }, [finish]);

  useEffect(() => {
    if (
      selectNews?.news_id &&
      !isOpenAddUpdateNewsModal &&
      !isOpenNewsViewModal
    ) {
      let updateFormData = { ...formData };
      updateFormData.titleEN.value = selectNews?.title["en"];
      const description = htmlToDraft(selectNews?.content["en"]);
      setEditorState(EditorState.createEmpty());

      if (description && description.contentBlocks) {
        const contentState = ContentState.createFromBlockArray(
          description.contentBlocks
        );
        setEditorState(EditorState.createWithContent(contentState));
      }

      setFormData(updateFormData);
    } else {
      clearAll();
    }
  }, [selectNews]);

  const generateKeywords = async () => {
    setIsLoading(true);
    const updateNewsForm = { ...formData };
    try {
      const body = {
        title: updateNewsForm.titleEN.value,
      };
      const response = await getNewsKeywords(body, "en");
      console.log({ response });
      if (response?.data?.status) {
        setSuggestions(response?.data?.data);
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  const updateNewsForm = { ...formData };

  return (
    <>
      <div className={"english-language-wrapper"}>
        <InputBox
          data={updateNewsForm.titleEN}
          onChange={async (e) => {
            e.preventDefault();
            await handleChange(e.target.value, updateNewsForm.titleEN.key);
          }}
        />

        {/* <TextArea
          data={updateNewsForm.descriptionEN}
          onChange={async (e) => {
            e.preventDefault();
            await handleChange(
              e.target.value,
              updateNewsForm.descriptionEN.key
            );
          }}
        /> */}
        {/* <Button
          data={{
            btnName: "GENERATE KEYWORD",
            buttonType: "black-border mr-2 mb-3",
            buttonSize: "lg",
            isLoading: isLoading,
            disable:
              updateNewsForm.titleEN.value === ""
                ? "black-border disabled mr-2 mb-3"
                : "",
          }}
          onClick={async () => {
            console.log("clicked...");
            await generateKeywords();
          }}
        /> */}

        <div className="suggestion_key">
          <div className="sk_title">English Keyword Suggestions</div>

          {Array.isArray(suggestion) && suggestion.length > 0
            ? suggestion.map((item) => (
                <KeywordCheckBox
                  data={{ keyword: item, isSelect: selectKeyword === item }}
                  onClick={() => {
                    let updatedForm = { ...formData };
                    updatedForm.keyWord.value = item?.replace(/ /g, "-");
                    setSelectKeyword(item);
                  }}
                />
              ))
            : ""}
        </div>

        <InputBox
          data={updateNewsForm.keyWord}
          onChange={async (e) => {
            e.preventDefault();
            await handleChange(e.target.value, updateNewsForm.keyWord.key);
          }}
        />
        {updateNewsForm.keyWord.value && (
          <>
            <div className="news-url">
              {"https://hopeofanewera.org/" + updateNewsForm.keyWord.value}
            </div>
          </>
        )}
        <label className={"txt-label"}>
          Description <b>*</b>
        </label>
        <div className={"rich-text-editor-wrapper"}>
          <Editor
            editorState={editorState}
            wrapperClassName="demo-wrapper"
            editorClassName="demo-editor"
            onEditorStateChange={onEditorStateChange}
            toolbar={{
              fontFamily: {
                options: ["gothambook"],
                className: undefined,
                component: undefined,
                dropdownClassName: undefined,
              },
              fontSize: {
                icon: undefined,
                options: [11, 12, 13, 14, 18, 24],
                className: undefined,
                component: undefined,
                dropdownClassName: undefined,
              },
            }}
          />
        </div>
      </div>
    </>
  );
};
export default English;
